import { render, staticRenderFns } from "./create-tickets.vue?vue&type=template&id=679c4948&"
import script from "./create-tickets.vue?vue&type=script&lang=js&"
export * from "./create-tickets.vue?vue&type=script&lang=js&"
import style0 from "./create-tickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports